meedy.factory('meedy.priceListService', ['$q', '$translate', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, $translate, baseService, objectHelper, config) {

        function PriceListService() {

            this.savePricelist = function (resourcePriceList) {
                return baseService.post(config.API_URL + '/pricelists', resourcePriceList).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, ResourcePriceListMeedyVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.savePricelistForAbc = function (resourcePriceList) {
                return baseService.post(config.API_URL + '/pricelists/savePricelistAbc', resourcePriceList).then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, ResourcePriceListMeedyVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getPriceListForMedicalPost = function () {
                return baseService.get(config.API_URL + '/pricelists/pricelistForMedicalPost').then(
                    function (successResponse) {
                        var data = objectHelper.translateObject(successResponse, ResourcePriceListMeedyVO);
                        return data;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getLocalPriceList = function () {
                return baseService.get('./meedy/resource/docs/visit.json').then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getPriceListBasedOnSpecializations = function (specializationIds) {
                return baseService.get(config.API_URL + '/offers/offersForSpecializations/' + specializationIds).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.saveMedicalPostPricelist = function (priceList) {
                return baseService.post(config.API_URL + '/pricelists/saveMedicalPostPricelist', priceList).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new PriceListService();
    }
]);
